// ErrorBoundary.js

import { Component } from "react";

class ErrorBoundary extends Component {
  componentDidCatch(error) {
    const { errorHandler } = this.props;
    if (errorHandler) {
      errorHandler(error);
    }
  }

  render() {
    return this.props.children;
  }
}

export default ErrorBoundary;
